import React from 'react'
import '../styles/ScienceBaseFooter.scss'

const version = process.env.REACT_APP_VERSION

const ScienceBaseFooter = () => {
  return (

    <div id="sb-footer">
      <div id="appfooter" className="container-fluid">
        <div className="sb-footerbar">
          <ul>
            <li>ScienceBase File Manager Version: {version}</li>
            <li>| <a href="https://www.sciencebase.gov/catalog/issueCollector">Report a Problem</a></li>
            <li>| <a title="For General Contact/Questions" target="_blank" rel="noopener noreferrer" href="mailto:sciencebase@usgs.gov">For General Contact/Questions</a></li>
            <li>| <a href="https://www.sciencebase.gov/catalog/notify/">ScienceBase Notify</a></li>
          </ul>
        </div>
      </div>
    </div>

  )
}

export default ScienceBaseFooter
